var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          title: _vm.isInEditMode
            ? _vm.$t("pages.admin.blog.create_edit.title_edit") +
              ": " +
              _vm.title
            : _vm.$t("pages.admin.blog.create_edit.title_create")
        }
      }),
      _vm._v(" "),
      _vm.current_thumbnail_url !== null
        ? _c("img", {
            staticClass: "img-fluid mb-4 rounded",
            attrs: { src: _vm.current_thumbnail_url }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "card shadow-sm" }, [
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("label", [
              _vm.isInEditMode
                ? _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("pages.admin.blog.create_edit.replace_thumbnail")
                      )
                    )
                  ])
                : _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("pages.admin.blog.create_edit.select_thumbnail")
                      )
                    )
                  ])
            ]),
            _vm._v(" "),
            _c("input", {
              staticClass: "file-upload-default",
              class: { "is-invalid": _vm.$errors.has("image") },
              attrs: { type: "file", id: "image" },
              on: { change: _vm.imageSelected }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "input-group cursor-pointer col-xs-12",
                on: { click: _vm.showSelectFileDialog }
              },
              [
                _c("input", {
                  staticClass: "form-control file-upload-info",
                  attrs: {
                    type: "text",
                    id: "image-upload",
                    disabled: "",
                    placeholder: _vm.$t(
                      "pages.admin.blog.create_edit.select_thumbnail"
                    )
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "input-group-append" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "file-upload-browse btn btn-gradient-primary",
                      attrs: { type: "button" }
                    },
                    [_vm._v(_vm._s(_vm.$t("actions.select")))]
                  )
                ]),
                _vm._v(" "),
                _c("error", { attrs: { input: "image" } })
              ],
              1
            ),
            _vm._v(" "),
            _c("small", { staticClass: "form-text text-muted" }, [
              _vm._v(
                _vm._s(
                  _vm.$t("pages.admin.blog.create_edit.thumbnail_explanation")
                )
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", { attrs: { for: "title" } }, [
                _vm._v(_vm._s(_vm.$t("pages.admin.blog.model.title")))
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.title,
                    expression: "title"
                  }
                ],
                staticClass: "form-control form-control-lg",
                class: { "is-invalid": _vm.$errors.has("title") },
                attrs: {
                  id: "title",
                  type: "text",
                  placeholder: _vm.$t("pages.admin.blog.model.title")
                },
                domProps: { value: _vm.title },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.title = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("error-no-form-field", { attrs: { input: "title" } })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", { attrs: { for: "contents" } }, [
                _vm._v(_vm._s(_vm.$t("pages.admin.blog.model.contents")))
              ]),
              _vm._v(" "),
              _c("VueTrix", {
                attrs: {
                  id: "contents",
                  placeholder: _vm.$t("pages.admin.blog.model.contents")
                },
                model: {
                  value: _vm.contents,
                  callback: function($$v) {
                    _vm.contents = $$v
                  },
                  expression: "contents"
                }
              }),
              _vm._v(" "),
              _c("error-no-form-field", { attrs: { input: "contents" } })
            ],
            1
          ),
          _vm._v(" "),
          _vm.isInEditMode && _vm.existingFiles.length
            ? _c("div", { staticClass: "form-group" }, [
                _c("label", [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.$t("pages.admin.blog.create_edit.existing_files")
                      ) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row" },
                  _vm._l(_vm.existingFiles, function(file) {
                    return _c(
                      "div",
                      { key: file.id, staticClass: "col-md-6" },
                      [
                        _c("div", { staticClass: "card bg-light mb-2" }, [
                          _c("div", { staticClass: "card-body p-2" }, [
                            _vm.isFileSelectedForDeletion(file)
                              ? _c("div", [
                                  _c("del", { staticClass: "text-danger" }, [
                                    _c("strong", [_vm._v(_vm._s(file.name))]),
                                    _vm._v(
                                      "\n                                        (" +
                                        _vm._s(
                                          _vm.convertBytesToHumanReadable(
                                            file.size
                                          )
                                        ) +
                                        ")\n                                    "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-sm btn-outline-success float-right",
                                      on: {
                                        click: function($event) {
                                          return _vm.selectExistingFile(file)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(_vm.$t("actions.keep")) +
                                          "\n                                    "
                                      )
                                    ]
                                  )
                                ])
                              : _c("div", [
                                  _c("span", [
                                    _c("strong", [
                                      _vm._v(_vm._s(file.name) + " ")
                                    ]),
                                    _vm._v(
                                      "\n                                        (" +
                                        _vm._s(
                                          _vm.convertBytesToHumanReadable(
                                            file.size
                                          )
                                        ) +
                                        ")\n                                    "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-sm btn-outline-danger float-right",
                                      on: {
                                        click: function($event) {
                                          return _vm.selectExistingFile(file)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(_vm.$t("actions.delete")) +
                                          "\n                                    "
                                      )
                                    ]
                                  )
                                ])
                          ])
                        ])
                      ]
                    )
                  }),
                  0
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", { attrs: { for: "fileDropzone" } }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.$t("pages.admin.blog.create_edit.upload_files")
                    ) +
                    "\n                "
                )
              ]),
              _vm._v(" "),
              _vm.dropzoneOptions !== null
                ? _c("vue-dropzone", {
                    ref: "fileDropzone",
                    attrs: { id: "fileDropzone", options: _vm.dropzoneOptions },
                    on: {
                      "vdropzone-files-added": _vm.dropzoneFilesAdded,
                      "vdropzone-removed-file": _vm.dropZoneFileRemoved
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "btn btn-primary", on: { click: _vm.saveSeries } },
            [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.isInEditMode
                      ? _vm.$t("actions.update")
                      : _vm.$t("actions.create")
                  ) +
                  "\n            "
              )
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }